import React from 'react';

const UploadIcon = ({ width = 50, height = 40, color = 'currentColor', ...rest }) => (
  <svg
    viewBox="0 0 50 40"
    width={width}
    height={height}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0007 23.3143C17.6551 22.9566 17.656 22.3751 18.0016 22.0174L25.4044 14.3545L32.8052 22.0145C33.1517 22.3731 33.1508 22.9566 32.8033 23.3143L32.7977 23.3201C32.453 23.6759 31.8955 23.6739 31.5518 23.3172L26.2886 17.8561V38.4319C26.2886 38.9411 25.8903 39.3545 25.3987 39.3545C24.9081 39.3545 24.5097 38.9411 24.5097 38.4319V17.8561L19.2494 23.3143C18.9047 23.672 18.3453 23.672 18.0007 23.3143Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.1388 14.067C41.1388 13.9331 41.1599 13.7992 41.1599 13.6643C41.1599 6.47254 35.3621 0.64502 28.3352 0.64502C23.2733 0.64502 18.9137 3.67654 16.8711 8.06062C15.9817 7.60228 14.9935 7.34525 13.9285 7.34525C10.678 7.34525 7.98775 9.98489 7.46007 13.161C3.59551 14.5146 0.806458 18.3846 0.806458 22.8136C0.806458 28.3734 5.21022 32.9031 10.6454 32.9031H19.8031C20.2885 32.9031 20.6819 32.5024 20.6819 32.0079C20.6819 31.5144 20.2885 31.1127 19.8031 31.1127H10.7336C5.89621 31.1127 2.02685 26.7677 2.65143 21.6947C3.05535 18.41 5.4021 15.7088 8.47322 14.6289L9.01913 14.4364L9.18415 13.4523C9.57944 11.0355 11.6115 9.05647 14.0053 9.05647C14.7632 9.05647 15.5096 9.23531 16.1899 9.593L17.6731 10.3533L18.386 8.82192C20.2099 4.91769 24.107 2.40119 28.3132 2.40119C34.3854 2.40119 39.3936 7.24459 39.3936 13.463C39.3936 14.9504 39.3705 15.7342 39.3705 15.7342L41.0399 15.745C45.059 15.8007 48.2433 19.4811 48.2433 23.6082C48.2433 27.7245 44.9707 31.0912 40.9411 31.1127H40.59H30.7837C30.2982 31.1127 29.9058 31.5144 29.9058 32.0079C29.9058 32.5024 30.2982 32.9031 30.7837 32.9031H40.9968C45.9378 32.9031 50 28.7311 50 23.6424C50 18.5527 46.1019 14.0787 41.1388 14.067Z"
    />
  </svg>
);

export default UploadIcon;
